import {Cirf} from "../cirf/cirf";

export interface SessionStorageKeys {
  tokens : string;
  sessionId : string;
  user : string;
  connectToken : string;
  customerAccountId: string;
  cirf : string;
  matterTransactions: string;
  matterSummaryAvailable: string;
  userId: string;
  cirfConfig: string; // We save this in case the user press F5
}

export const SESSION_STORAGE_KEYS : SessionStorageKeys = {
  tokens : 'dppm_tokens',
  sessionId  : 'dpsessionid',
  user  : 'user',
  connectToken : 'connectToken',
  customerAccountId : 'customerAccountId',
  cirf : 'cirf',
  matterTransactions : 'matterTransactions',
  matterSummaryAvailable: 'matterSummaryAvailable',
  userId: 'userId',
  cirfConfig: 'cirfConfig'
};
